<template>
  <div class="league-runs">
    <v-chip>{{ runs.length }}</v-chip>
    <div class="d-flex">
      <v-switch
        v-model="isPlay"
        :label="isPlay ? 'UP' : 'SP'"
        @change="fetchRuns"
      />
      <v-switch
        v-model="isAsc"
        :label="isAsc ? 'Nopein ensin' : 'Hitain ensin'"
        @change="fetchRuns"
        class="ml-4"
      />
    </div>
    <v-btn @click="fetchRuns" small color="primary" class="mb-4">Refresh</v-btn>
    <v-alert v-if="error" type="error">{{ error }}</v-alert>
    <v-progress-circular v-if="loading" indeterminate color="primary" />
    <v-list v-if="runs.length">
      <RunListItem
        v-for="(run, idx) in runs"
        :key="run.id"
        :run="run"
        :prevEventId="idx > 0 ? runs[idx - 1].event_id : null"
        @deleted="removeRun"
      />
    </v-list>
    <div v-else-if="!loading && !error">No runs found for this year.</div>
  </div>
</template>

<script>
import ax from '@/utils/axios/axios';
import RunListItem from './RunListItem.vue';

export default {
  name: 'LeagueRuns',
  components: { RunListItem },
  data: () => ({
    runs: [],
    loading: false,
    error: null,
    isPlay: false,
    isAsc: false
  }),
  mounted() {
    this.fetchRuns();
  },
  methods: {
    async fetchRuns() {
      this.loading = true;
      this.error = null;
      try {
        const params = [`league_id=${this.$route.params.league_id}`];
        if (this.isPlay) {
          params.push('is_play=1');
        } else {
          params.push('is_play=0')
        }
        params.push(`order=${this.isAsc ? 'ASC' : 'DESC'}`);
        const res = await ax.get(`/admin/runs/this-year?${params.join('&')}`);
        this.runs = res.data;
      } catch (e) {
        this.error = e.response?.data?.error || 'Failed to fetch runs';
      } finally {
        this.loading = false;
      }
    },
    removeRun(id) {
      this.runs = this.runs.filter(run => run.id !== id);
    }
  }
}
</script>

<style scoped>
.league-runs {
  padding: 24px;
}
</style>